export const optionTitle_mailHandling = "iirK$d";
export default {optionTitle_mailHandling};